import { httpRequest } from "../../../utils/HttpRequest";
import { ITurnoverList, ITurnoverSearch } from "./turnoverTypes"
class Turnoverservice {
    async turnover(params: ITurnoverSearch) {
        const apiUrl = `/statement/turnover`;
        return await httpRequest.post<ITurnoverList>(apiUrl, params);
    }
    async turnoverExcel(params: ITurnoverSearch) {
        const apiUrl = `/statement/turnoverExcel`;
        return await httpRequest.postFile(apiUrl, params, { timeout: 600000 });
    }
}
export const turnoverService = new Turnoverservice();
